<template>
  <section class="content">
    <loader v-show="loading"></loader>
    <vuetable
      v-show="!loading"
      v-on:table-delete-request="deleteEntity"
      v-on:table-edit-request="handleEdit"
      :showEdit="true"
      :showDelete="true"
      :tableData="tableData"
      :tableTitle="'Currencies'"
      :fields="[{ header: 'Name', prop: 'name', hideByDefault: false }, { header: 'Code', prop: 'code', hideByDefault: false }]"
      v-on:pages-remaining="loadMore"
      :maxItems="maxValue"
    ></vuetable>
  </section>
</template>
<script>
  import vuetable from '../../../helpers/VueTable.vue'
  import Loader from '../../../helpers/Loader.vue'
  import AdminSearchResults from '../../mixins/AdminSearchResultsMixin.js'
  export default {
    name: 'CurrencySearchResults',
    components: {
      vuetable: vuetable,
      Loader
    },
    mixins: [ AdminSearchResults ],
    data () {
      return {
        loading: false,
        tableData: [],
        entityName: 'currency',
        editEntityScreen: 'Admin - Edit/View Currency'
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// CurrencySearchResults.vue?30c4da24